import { API_AUTH_REGISTER_WITH_CHECKOUT } from '@/shared/constants/bff-endpoints';
import type { RegistrationFormData } from '@/shared/lib/validation/registration';


type Success = { ok: true; checkoutUrl: string | null };
type Failure = { ok: false; error: string };

export type RegisterWithCheckoutResult = Success | Failure;


export const registerWithCheckout = async (
    payload: RegistrationFormData,
): Promise<RegisterWithCheckoutResult> => {
    console.log({ payload });

    try {
        const response = await fetch(API_AUTH_REGISTER_WITH_CHECKOUT, {
            method : 'POST',
            headers: { 'Content-Type': 'application/json' },
            body   : JSON.stringify(payload),
        });

        return await response.json() as RegisterWithCheckoutResult;
    } catch (e) {
        const error = e instanceof Error ? e.message : 'Registration failed';
        return { ok: false, error };
    }
};
